/**
 * @title Shoppinglistshelper.js: Sub-module
 * @description 
 * This JS file binds the create list with item 
 * and add item to list functionalities to 
 * respective event listeners
 * 
 */
define([], function() {
    var Shoppinglistshelper = {
        init : function() {
    		// initializes the validate methods
    		Shoppinglistshelper.validate();
        	// initializes the basic bindings
    		Shoppinglistshelper.initialize();
        },
        /**
         * The method contains all the validation rules
         * related patterns and validator methods.
         */
        validationRules : function(){
        	// Regex patterns for validation.
        	var regexes = {
        		LIST_NAME : /^[a-z0-9 \/,'@!*_+~#$%^&\-|\.`\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]{1,40}$/i,
        		HTML_TAG : /<(\"[^\"]*\"|'[^']*'|[^'\">])*>/,
        		QUANTITY : /^([1-9][0-9]{0,2})$/,
        		QUANTITYBD :/^([1-9][0-9]{0,3})$/
        	}
        	// List name specific validation
	    	 $.validator.addMethod("listname", function( value, element) {
					return  this.optional(element) || regexes.LIST_NAME.test(value);
			}, messages.ERR_ENTER_LISTNAME);
        	
        	 $.validator.addMethod("quantitystr", function( value, element) {
        		 	var pattrn=regexes.QUANTITY;
        		 	if($('#isBDAppVar').val() == 'BD'){
        		 		pattrn=regexes.QUANTITYBD;
        		 	}
					return  this.optional(element) || pattrn.test($.trim(value)) && !regexes.HTML_TAG.test(value);
			}, messages.ERR_INVALID_QUANTITY);
        },
        /**
         * The method maps different forms to the 
         * respective validation.
         */
        validate: function(){
        	Shoppinglistshelper.validationRules();
	    	$("#addtolistform").validate({
    			rules: {
			 			quantity: {required: true, quantitystr: true }
				   },
				messages: {
					   	quantity : {required: messages.ERR_INVALID_QUANTITY, quantitystr: messages.ERR_INVALID_QUANTITY}
				   },
				errorPlacement : function(error, element) {
					   $('.errormsg-box').show().html(error);
				},
				invalidHandler : COSTCO.util.invalid_handler,
				highlight : COSTCO.util.highlightWithErrorLabel,
				unhighlight : COSTCO.util.unhighlightWithErrorLabel
			});
	    	$('#addtonewlistform').validate({
    			rules: {
	 					quantity: {required: true, quantitystr: true },
	 					listidname: {required: true, listname: /^$/ }
				   },
				messages: {
					   	quantity : {required: messages.ERR_INVALID_QUANTITY, quantitystr: messages.ERR_INVALID_QUANTITY},
				   		listidname: {required: messages.ERR_ENTER_LISTNAME}
				   },
				errorPlacement : function(error, element) {
					   if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
					  	 error.addClass("new-list-error-v2");
					   }
					   element.parent().find(".form-error-text").html(error).show();
				},
				invalidHandler : COSTCO.util.invalid_handler,
				highlight : COSTCO.util.highlightWithErrorLabel,
				unhighlight : COSTCO.util.unhighlightWithErrorLabel
			});
        },
        /**
         * The method initializes the binding for different 
         * JSP elements and is the starting point for most of 
         * the actions.
         */
        initialize : function(){
        	// Binding for add to list in cart section
        	$('body').on('click','.list-linktrigger',function (event) {
        		Shoppinglistshelper.redirect(event,Shoppinglistshelper.openLists(event));
        	});
        	
        	// Binding for add to list in cart section mobile view
        	$('body').on('click','.list-link',function (event) {
        		Shoppinglistshelper.redirect(event,Shoppinglistshelper.openLists(event));
        	});
        	// Binding for add to list in PLP/ featured products
        	$('.menuicon-image').unbind('click').click(function (event) {
        		event.preventDefault();
            	event.stopImmediatePropagation();
        		Shoppinglistshelper.redirect(event,Shoppinglistshelper.openListsModal(event));
        	});
        	$('.menuicon-image').unbind('keydown').keydown(function (event) {
        		if(event.which === 13){
        			this.click();
        		}
        	});
        	// Binding for add to list in PDP.
        	$('.pdp-lists-link').unbind('click').click(function (event) {
        		var redirecturl = $('.pdp-lists-link').attr('data-no-login');
        		redirecturl = redirecturl.split('?')[0] + '?' + encodeURIComponent(redirecturl.split('?')[1]);
        		let callerElement = event.target;
        		COSTCO.dialog.returnFocusOnCallerElement(callerElement);
        		Shoppinglistshelper.redirect(event,Shoppinglistshelper.openProductListsModal(event),redirecturl);
        	});
        	// Since it is dynamic pop-up need to handle enter action.
        	$('body').on('submit', '#addtolistform',function(event){
	    		event.preventDefault();
	         	event.stopImmediatePropagation();
	         	Shoppinglistshelper.addToList();
	    	 });
        	
        	$('body').on('submit', '#addtonewlistform',function(event){
	    		event.preventDefault();
	         	event.stopImmediatePropagation();
	         	Shoppinglistshelper.addToNewList();
	    	 });
        	
        	$('body').on('submit', '#addtolistformorder',function(event){
	    		event.preventDefault();
	         	event.stopImmediatePropagation();
	         	Shoppinglistshelper.addToListFromCartDropDown();
	    	 });
        	
        	$('body').on('submit', '#addtonewlistformorder',function(event){
	    		event.preventDefault();
	         	event.stopImmediatePropagation();
	         	Shoppinglistshelper.addToNewListFromCart();
	    	 });
        	
        },
        /**
         * This method is used in the PLP/featured sections to get
         * parameters for the modal pop-ups.
         */
        openListsModal :  function (event){
        	//Updating modal parameters
        	var product = $(event.currentTarget).closest('.product-tile-set');
    		var params ={
        			event: event,
        			image: product.find('.thumbnail img:not(.menuicon-image)').clone(),
        			desc: product.find('.description').text().trim(),
            		price: product.find('.price[data-regionnav=DEFAULT]:visible').text().trim(),
            		partnumber: product.find('.partNumb').val(),
            		catentryid: product.find('.catEntryId').val(),
            		isDataMask : product.data('private') != undefined && product.data('bi-private') != undefined ,
            		authtoken: ListsFormDynamicObject.authToken,
            		quantity: product.find('input[name^=quantity-]').val()            		
        		}
        	// Invokes the pop-up modal.
        	Shoppinglistshelper.showListModal(params);
        	
        	
		},
		/**
		 * This method is used in cart dropdown section to
		 * dynamically get the modal pop-up parameters
		 * and invokes the respective pop-up. 
		 */
        openCartListsModal :  function (event){
        	var params ={
    			event: event,
        		authtoken: ListsFormDynamicObject.authToken
    		}
        	// Invokes the pop-up modal.
        	Shoppinglistshelper.showListModalForCart(params);
        	
		},
		getClientIdFromResponse(data){
			var token = null;
			if(data && data.clientId && /^\d{4,},.+$/.test(data.clientId)){
				token = encodeURIComponent(data.clientId);
			}
			return token;
		},
		/**
		 * Method displays the initial list popup
		 * in cart dropdown.
		 */
		showListModalForCart(params){
			$.ajax({
       		 	url: '/AjaxGetShoppingListCmd',
                type: 'POST',
                dataType: 'json',
                success: function(data, textStatus, xhr){
					shoppinglist = data.shoppinglist;
					var token = Shoppinglistshelper.getClientIdFromResponse(data);
					if(token != null){
						params.authtoken = token;
						$('INPUT[name="authToken"]').val(token);
						if(window.ListsFormDynamicObject){
							window.ListsFormDynamicObject.authToken = token;
						}
					}
					var listdropdown='';
					shoppinglist.forEach((list, i) => {
						listdropdown = listdropdown+(COSTCO.util.tmpl('tmpl_list_dropdown', list));
					});
					COSTCO.dialog.createExtDialogBox({
			    		title : messages.ADD_TO_LIST,
			    		body : COSTCO.util.tmpl('tmpl_lists_integration_addorder_modal',{
	     					authtoken: params.authtoken,
	     					listdropdown: listdropdown
	     				}),
			    		primary : messages.ADD_TO_LIST,
			    		primary_event : function() {Shoppinglistshelper.addToListFromCartDropDown(); },
			    		secondary : messages.JS_DIALOG_CANCEL,
			    		onshown : function(e){
							Shoppinglistshelper.setFocusForPopup(e);
						},
						onclose: function(e){
							$("select[id=cart-options]").each(function() { this.selectedIndex = 0 });
		    				$("label[for='cart-options']").removeClass("active");
						},
			    	});
		        	// Bind an on change to the dropdown, if the option selected is the
		        	// create new list then open a different modal
		        	$("#costcoModal").on("change", "#listformorder-select-dropdown", function(e){
		        		if(this.value == "newList"){
		        			$('#costcoModal').modal('hide').on('hidden.bs.modal', function (e) {
			                    	Shoppinglistshelper.openCreateListsModalFromCart(params);
			                    	$('#costcoModal').off('hidden.bs.modal');
		
			                });
		        		} 
		        		else {
		        			let listName = $(this).find(':selected').text().trim();
		        			$('#addtolistformorder #listname').val(listName);
		        		}
		        	})		        	
		        	// Pop up logic for lists.
		        	Shoppinglistshelper.listActions();
			 	 },
 				 failure: function(data, textStatus, xhr){
 					 $('.err-box').html("<label class='error'>" + data.errorMessage + "</label>").show();
 				 }
		      });	
		},
		/**
		 * Method handles the add item to list operation
		 * in cart dropdown.
		 */
		addToListFromCartDropDown :  function (){
			// Validation
			Shoppinglistshelper.validate();
			var listid = $("#listformorder-select-dropdown").val(),
    	   	 	 form = $('#addtolistformorder');
         	 // If form is valid then invokes the command to add item to list
			 if( listid == '-1'){
				 $('.errormsg-box').html("<label class='sr-only'>" + messages.ERROR + "</label>").show();
				 $('.errormsg-box').append("<label class='error'>" + messages.ERR_SELECT_LIST + "</label>").show();
			 } else if (form.valid()){
         			COSTCO.util.input_injector('#addtolistformorder', {
         				requisitionListId: listid,
         				name: '',
         				azureEntries: Shoppinglistshelper.buildAzurelist(),
         				orderId: $("#ShopCartForm input[name=orderId]").val()
                      }); 
         		
         		Shoppinglistshelper.ajaxCall(form.serializeArray(),
         				Shoppinglistshelper.addtolistdone,Shoppinglistshelper.addtolisterr);
         	 }
         },
         buildAzurelist(){
        	 var azureEntries = {};
        	 $('.azure-entries').each(function(){
        		 azureEntries [$(this).attr('data-orderitemnumber')]= $(this).attr('data-quantity');
        	 });
        	 return JSON.stringify(azureEntries);
         },
         /**
 		 * Method used to open the create new list with item
 		 * modal used in cart dropdown.
 		 */
 		openCreateListsModalFromCart :  function (params){
         	
        	 COSTCO.dialog.createExtDialogBox({
		    		title : messages.MA_CREATELIST,
		    		body : COSTCO.util.tmpl('tmpl_list_integration_order_create_new_modal',{
      					authtoken: params.authtoken
      				}),
		    		primary : messages.MA_CREATELIST,
		    		primary_event : function() {Shoppinglistshelper.addToNewListFromCart(); },
		    		secondary : messages.JS_DIALOG_CANCEL,
		    		onshown : function(e){
						Shoppinglistshelper.setFocusForPopup(e);
					},
					onclose: function(e){
						//Logic to reset dropdown
						$('#cart-options').val("-1");
					},
		    	});
 		},
 		/**
         * The method is used to create new list with item
         * in cart dropdown.
         */
        addToNewListFromCart :  function (){
       	 
       	 Shoppinglistshelper.validate();
   	   	 var form = $('#addtonewlistformorder');
        	 // If form is valid then invokes the command to add item to list
        	 if (form.valid()){
        		 $('#addtonewlistformorder input[name=name]').remove();
        			COSTCO.util.input_injector('#addtonewlistformorder', {
        				name: $("#addtonewlistformorder input[name=listidname]").val(),
        				orderId: $("#ShopCartForm input[name=orderId]").val(),
        				requisitionListId: '-1001',
        				azureEntries: Shoppinglistshelper.buildAzurelist(),
                     });
        		
        		Shoppinglistshelper.ajaxCall(form.serializeArray(),
        				Shoppinglistshelper.addtonewlistdone,Shoppinglistshelper.addtonewlisterr);
        	 }
        },
		/**PDP section to
		 * dynamically get the modal pop-up parameters
		 * and invokes the respective pop-up. 
		 */
        openProductListsModal :  function (event){
        	//Updating modal parameters
        	var product = $(event.currentTarget).closest('#product-page');
        		image = product.find('#productImageOverlay').clone();
        		// Specifically added to handle the OOS scenario.
    		var imageHolder = $("<div>");
    		image.find("img").each(function(index, img){
    			var temp = "";
    			img = $(img);
    			temp = img.removeAttr("style","id").addClass("img-responsive");
    			imageHolder.append(temp);
    		});
    		imageHolder.css({"position" : "relative"});
    		var prodDesc = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? product.find('#product-details .product-h1-container-v2 h1').html().trim().replaceAll('<br>', ', ') : product.find('#product-details .product-h1-container h1').html().trim().replaceAll('<br>', ', ')
    		var params ={
    			event: event,
    			image: imageHolder,
    			desc: prodDesc,
        		price: Shoppinglistshelper.getFormattedPrice(product.find('.your-price .value').text().trim()),
        		partnumber:product.find('.item-number span').html(),
        		catentryid: product.find('#catEntryId').val(),
        		authtoken: ListsFormDynamicObject.authToken,
        		isDataMask : product.data('private') != undefined && product.data('bi-private') != undefined ,
        		quantity:product.find('input[name=quantity]').val()
    		};
        	// Invokes the pop-up modal.
        	Shoppinglistshelper.showListModal(params);
        	
        	
		},		
		/**
		 * The method is used to open the add item to list modal
		 * and the create list with item modal bindings are also 
		 * handled here.
		 */
		showListModal(params){
			try {
			    if($.isEmptyObject($.cookie('hashedUserId'))) {
			        return;
			    } 
			} catch(e){} // ignore
			$.ajax({
       		 	url: '/AjaxGetShoppingListCmd',
                type: 'POST',
                dataType: 'json',
                success: function(data, textStatus, xhr){
					shoppinglist = data.shoppinglist;
					var token = Shoppinglistshelper.getClientIdFromResponse(data);
					if(token != null){
						params.authtoken = token;
						$('INPUT[name="authToken"]').val(token);
						if(window.ListsFormDynamicObject){
							window.ListsFormDynamicObject.authToken = token;
						}
					}
					var listdropdown='';
					shoppinglist.forEach((list, i) => {
						listdropdown = listdropdown+(COSTCO.util.tmpl('tmpl_list_dropdown', list));
					})
					Shoppinglistshelper.createmodal(
		    				messages.ADD_TO_LIST, params.isDataMask ? 'tmpl_lists_integration_fsachd_additem_modal' : 'tmpl_lists_integration_additem_modal', 
		    				messages.ADD_ITEM, 
		     				function() {Shoppinglistshelper.addToList(); },
		     				messages.JS_DIALOG_CANCEL,{
		     					desc: params.desc,
		     					partnumber: params.partnumber,
		     					price: params.price,
		     					catentryid: params.catentryid,
		     					authtoken: params.authtoken,
		     					listdropdown: listdropdown,
		     					quantity:($('#isBDAppVar').val() == 'BD' && params.quantity)?params.quantity:1
		     				}
		     			 );
		        	
		        	$('#imagetag').html(params.image);
		        	// Bind an on change to the dropdown, if the option selected is the
		        	// create new list then open a different modal
		        	$("#costcoModal").off("change", "#list-select-dropdown").on("change", "#list-select-dropdown", function(e){
		        		if(this.value == "newList"){
		        			params.quantity= $('.quantityfield').val();
			        		$('#costcoModal').modal('hide').on('hidden.bs.modal', function (e) {
			                    	Shoppinglistshelper.openCreateListsModal(params);
			                    	$('#costcoModal').off('hidden.bs.modal');
		
			                });
		        		} 
		        		else {
		        			let listName = $(this).find(':selected').text().trim();
		        			$('#addtolistform #listname').val(listName);
		        		}
		        	})
		        	// Pop up logic for lists.
		        	Shoppinglistshelper.listActions();
		        	let callerElement = event.target;
		        	COSTCO.dialog.returnFocusOnCallerElement(callerElement);
			 	 },
 				 failure: function(data, textStatus, xhr){
 					 $('.err-box').html("<label class='error'>" + data.errorMessage + "</label>").show();
 				 }
		      });
		},
		/**
		 * Method used to open the create new list with item
		 * modal used in PLP/PDP/Cart/Featured products.
		 */
		openCreateListsModal :  function (params){
        	Shoppinglistshelper.createmodal(
    				messages.MA_CREATELIST, 'tmpl_list_integration_create_new_modal', 
    				messages.MA_CREATELIST, 
     				function() {Shoppinglistshelper.addToNewList(); },
     				messages.JS_DIALOG_CANCEL,{
     					desc: params.desc,
     					partnumber: params.partnumber,
     					price: params.price,
     					catentryid: params.catentryid,
     					authtoken: params.authtoken,
     					quantity : params.quantity
     				}
     			 );
        	$('#createimagetag').html(params.image);
        	
		},
		/**
		 * The method is used to open the pop up for add
		 * to list feature in the Cart section.
		 */
        openLists :  function (event){
        	//Updating modal parameters
        	var orderitem = $(event.currentTarget).closest('.order-item');
    		var params ={
        			event: event,
        			image: orderitem.find('.item-thumbnail').html(),
        			desc: orderitem.find('.product-title a').text(),
            		price: Shoppinglistshelper.getFormattedPrice(orderitem.find('.itemPricePurchased').html()),
            		partnumber:orderitem.find('.itemPartNumberPurchased').html(),
            		catentryid: orderitem.find('.catalogEntryId').val(),
            		authtoken: ListsFormDynamicObject.authToken,
            		quantity:orderitem.find('input[name^=quantity_]').val()
        		}
	    		let callerElement = event.target;
	    		COSTCO.dialog.returnFocusOnCallerElement(callerElement);
        		Shoppinglistshelper.showListModal(params);
		},
		/**
		 * Method handles the add item to list operation
		 * in all the pages.
		 */
		addToList :  function (){
			// Validation
			Shoppinglistshelper.validate();
			var listid = $("#list-select-dropdown").val(),
    	   	 	 form = $('#addtolistform');
         	 // If form is valid then invokes the command to add item to list
			 if( listid == 'null'){
				 $('.errormsg-box').html("<labe class='sr-only'>" + messages.ERROR + "</label>").show();
				 $('.errormsg-box').append("<label class='error'>" + messages.ERR_SELECT_LIST + "</label>").show();
			 } else if (form.valid()){
         		COSTCO.util.input_injector('#addtolistform', {
                    ajaxFlag: 'true',
                  });
         		if($('#isBDAppVar').val() == 'BD'){ 
         			$('input[name=requisitionListId]').remove();
         			COSTCO.util.input_injector('#addtolistform', {
         				requisitionListId: listid
                      }); 
         		}
         		Shoppinglistshelper.ajaxCall(form.serializeArray(),
         				Shoppinglistshelper.addtolistdone,Shoppinglistshelper.addtolisterr);
         		Shoppinglistshelper.announceSrMessageForAddToListAction();
         	 }
         },
         /**
          * Success handling function for add item with existing list.
          */
         addtolistdone :function(data){
        	 if(null != data && data.errorMessageKey != null){
        		 $('.errormsg-box').html("<label class='error'>" + data.errorMessage + "</label>").show();
      		 }else{
      			$('.errormsg-box').html('');
      			var listurl = $('#listDetailUrl').val()+'&listId='+data.listId,
      				listname = $('input[name=listName]').val().trim();
      			Shoppinglistshelper.openModel($('#costcoModal'), listname,listurl );
      			COSTCO.util.announceSRMessage(messages.LISTS_ADDED_ITEMS_MSG);
      		 }
        	 
         },
         /**
          * Error handling function for add item with existing list.
          */
         addtolisterr : function(data){
        	 $('.errormsg-box').html("<label class='error'>" + data.errorMessage + "</label>").show();
         },
         /**
          * The method is used to create new list with item
          * in all pages.
          */
         addToNewList :  function (){
        	 Shoppinglistshelper.validate();
    	   	 var form = $('#addtonewlistform');
         	 // If form is valid then invokes the command to add item to list
         	 if (form.valid()){
         		COSTCO.util.input_injector('#addtonewlistform', {
                    ajaxFlag: 'true',
                  });
         		if($('#isBDAppVar').val() == 'BD'){ 
         			$('input[name=name]').remove();
         			COSTCO.util.input_injector('#addtonewlistform', {
         				name: $("#addtonewlistform input[name=listidname]").val(),
         				requisitionListId: '-1001'
                      });
         		}
         		Shoppinglistshelper.ajaxCall(
         			form.serializeArray(),
         			Shoppinglistshelper.addtonewlistdone,Shoppinglistshelper.addtonewlisterr
         		);
         	 }
         },
         /**
          * Success handling function for add item with new list.
          */
         addtonewlistdone :function(data){
        	 if(null != data && data.errorMessageKey != null){
        		 $('.err-box').html("<label class='error'>" + data.errorMessage + "</label>").show();
      		 }else{
      			$('.err-box').html('');
      			var listurl = $('#listDetailUrl').val()+'&listId='+data.listId,
  				listname = $('input[name=listidname]').val().trim();
      			Shoppinglistshelper.openModel($('#costcoModal'), listname,listurl );
      		 }
         },
         /**
          * Error handling function for add item with new list.
          */
         addtonewlisterr : function(data){
        	 $('.err-box').html("<label class='error'>" + data.errorMessage + "</label>").show();
         },
         /**
          * Common method to handle the ajax call which takes
          * the success response method and the form data as input.
          */
         ajaxCall : function(formdata, ajaxsuccess, ajaxerr){
         	$.ajax({
                 url: "/ManageWishListCmd",
                 type: 'POST',
                 data: formdata,
                 dataType: 'json',
                 timeout: 15000,
 				success: function(data, textStatus, xhr){
 	        		if (data.errorCode) {
 	                    if (data.errorCode == 2510) { // session timeout
 	                        document.location.href = 'Logoff?URL=ReLogonFormView';
 	                        return;
 	                    }
 	                }
         			ajaxsuccess(data, textStatus, xhr);
  				},
  				failure: function(data, textStatus, xhr){
  					if(textStatus === "timeout") {
 	        			console.log("Error timeout.");
 	        		} else {
 	        			ajaxerr(data);
 	        		}
  				},
  				error: function(data, textStatus, xhr) {
  					COSTCO.util.LoginTimeout.updateActivity();
 					if(textStatus === "timeout") {
	        			console.log("Error timeout.");
	        		} else if(data.errorCode && data.errorCode == 2510){
	        			document.location.href = 'Logoff?URL=ReLogonFormView';
	                    return;
	        		} else {
	        			var res = DOMPurify.sanitize(data.responseText)
	        			var prohiData = $("<div></div>").html(res),
 						msg = prohiData.find("#main_content_wrapper p").text(),
 					    header= prohiData.find("#main_content_wrapper h1").text();
	 					// Prohibited characters error
	 					if(msg && header && header=='Prohibited characters error'){
	 						var redirecturl = 'https://'+window.location.hostname+'/ProhibitedCharacterErrorView';
	 						console.log('redirecturl'+redirecturl);
	 						window.location.href= redirecturl;
	 					}else{
	 						$('#header-error-box').html(data.errorMessage).show();
	 					}
	        		}
 				}
 		    });
         	
         },
         /**
          * The method is used to handle the drop down menu operation
          * in the add item to list modal pop-up
          */
        listActions: function() {
            $(".dropdownarea").find(".ddl-custom .dropdown-menu>li[data-select-option]").on("click", function(e){
                var self = $(this);
                var parent = self.closest(".ddl-custom");
                parent.find(".dropdown-menu>li").show();
                parent.find(".dropdown-toggle").text(self.text());
                parent.attr("data-selected", self.attr("data-select-option"));
                $("input[id=listid]").val(self.attr("data-select-option"));
                $("input[id=listname]").val(self.text());
                $('.errormsg-box').html('');
                self.hide();
            });

    	
        },
        
        updateListAsSelectedMenuItem : function() {
        	COSTCO.Global.updateSelectedMenuItem('Lists.label');
        },
        
        /**
         * Method used to handle the add item to list success
         * scenarios.
         */
		openModel : function (current, listname, listurl){
            current.modal('hide').on('hidden.bs.modal', function (e) {
                setTimeout(function(e){
                	Shoppinglistshelper.createmodal(
            				messages.ADD_TO_LIST, 'tmpl_lists_add_item_success_modal', 
            				messages.VIEW_LIST, 
             				function() {window.location = listurl},
             				messages.CONTINUE_SHOPPING,
             				{listurl: listurl,listname: listname}
             			 );
					current.off('hidden.bs.modal');

                })
            });
        },
        /**
         * The method checks whether the user is logged in
         * else redirects to login page.
         */
        redirect: function(event,fnction,redirecturl){
        	event.preventDefault();
    		event.stopImmediatePropagation();
    		var c = $.cookie('hashedUserId');
    		
    		if(c && c != '""'){
    			fnction;
    		}else{
    			var sanitizedOrigin = DOMPurify.sanitize(window.location.origin);
    			var sanitizedSearch = DOMPurify.sanitize(window.location.search);
    			var redirectTemp = '',
    				path =window.location.pathname;
				if (redirecturl && path.indexOf('.html') != -1 && window.location.search.indexOf('&keyword=') != -1) {
					// Sanitize the redirecturl parameter if necessary
					var sanitizedRedirectURL =  DOMPurify.sanitize(redirecturl);
					var redirectTemp = sanitizedOrigin + '/CatalogSearch' + sanitizedSearch + '&identifier=' + path.substring(path.indexOf('/') + 1, path.lastIndexOf('.'));
					var url = sanitizedRedirectURL + '?storeId=' + wcs.storeId + '&URL=' + encodeURIComponent(redirectTemp);
				} else {
					var urlToSanitize = redirecturl ? redirecturl : window.location.href;
				    var redirectTemp = DOMPurify.sanitize(urlToSanitize);
				    var url = '/LogonForm?storeId=' + wcs.storeId + '&URL=' + encodeURIComponent(redirectTemp);
				}
    			
    			
    			window.location.href = url;
    		} 
        },
		/**
		 * The method takes the primary button name,
		 * secondary button name, modal template name, primary button success action
		 * method and the parameters required for the template and
		 * calls the existing pop-up framework to handle
		 * different pop-ups in the my account lists section.
		 */
		createmodal :function (title,body_tmpl,primary,primary_event,seconday,parameters){
			COSTCO.dialog.createExtDialogBox({
	    		title : title,
	    		body : COSTCO.util.tmpl(body_tmpl,parameters),
	    		primary : primary,
	    		primary_event : primary_event,
	    		secondary : seconday,
	    		onshown : function(e){
				Shoppinglistshelper.setFocusForPopup(e);
				}
	    	});
		},
		setFocusForPopup : function(e){
			var cntrl = $(e.currentTarget).find('input:not([type=hidden]):first');
			cntrl = (cntrl && cntrl.length > 0) ? cntrl : $(e.currentTarget).find('.close');
			cntrl.focus();
		},
		getFormattedPrice: function(price){
			var locale = COSTCO.util.getLocale();
			if (locale == 'fr-CA') {
			price = price + ' ' + '$';
			} else {
				price = '$' + price;
			}

			return price;
		},
		/**
		 * Announces to SR user that product is added to list
		 */
		announceSrMessageForAddToListAction : function(){
		    let productDesc = $("#description-prod")[0];
		    if(productDesc){
		        let srMessageAddToList = messages.SFL_ADD_TO_LIST.replace("{0}", productDesc.innerHTML);
		        COSTCO.util.announceSRMessage(srMessageAddToList);
     	    }
		}
		
    }
	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = new Object();
	}

	if (typeof window.COSTCO.Global == 'undefined') {
		document.addEventListener("CostcoGlobalLoaded", Shoppinglistshelper.init, false);
	}
	else {
		Shoppinglistshelper.init();
	}

	window.COSTCO.Shoppinglistshelper = Shoppinglistshelper;
    
});


// WEBPACK FOOTER //
// ./js/account/shoppinglistshelper.js